// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___ubxxx","root__disabled":"style-module__root__disabled___OjmkO","root__badge":"style-module__root__badge___eP1Ip","root__label":"style-module__root__label___yBpfO"};
    if(module.hot) {
      // 1729151130099
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  